import api from '../../api';
import toast from 'react-hot-toast';

export async function loadDataset({setToken, datasetId, password}) {
  console.log(setToken)
  const toastId = toast.loading("Loading..");
  api.post(
    "/submit/token",
    {
      username: datasetId,
      password: password,
    }, {
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    }
  ).then(response => {
      setToken(`Bearer ${response.data.access_token}`);
      toast.success("Sucessfully loaded dataset!", {id: toastId})
    }
  ).catch(e => {
      toast.error("Authentication failed!", {id: toastId})
      setToken(null);
    })
  };


const oemerPnas = {
    lipidClass: "CL",
    url: "https://doi.org/10.1073/pnas.1719407115",
    source: "Oemer et al. (2018)",
  }
const exampleDatasets = [
  {
    dataset: "Cell culture",
    datasetId: 1,
    password: "cell-culture",
    file: "/files/cell_culture.csv",
    ...oemerPnas
  },
  {
    dataset: "Model organisms (heart)",
    datasetId: 2,
    password: "organisms-heart",
    file: "/files/higher_animals.csv",
    ...oemerPnas
  },
  {
    dataset: "Model organisms (brain)",
    datasetId: 3,
    password: "organisms-brain",
    file: "/files/higher_animals.csv",
    ...oemerPnas
  },
  {
    dataset: "Insects and fish",
    datasetId: 4,
    password: "lower-organisms",
    file: "/files/lower_animals.csv",
    ...oemerPnas
  },
  {
    dataset: "Fungi",
    datasetId: 5,
    password: "fungi",
    file: "/files/fungi.csv",
    ...oemerPnas
  },
  {
    dataset: "Bacteria",
    datasetId: 6,
    password: "bacteria",
    file: "/files/bacteria.csv",
    ...oemerPnas
  },
  {
    dataset: "Plants",
    datasetId: 7,
    password: "plants",
    file: "/files/plants.csv",
    ...oemerPnas
  },
  {
    dataset: "Mouse liver",
    lipidClass: "PC, PE, PS, PI, PG",
    url: "https://doi.org/10.1038/nmeth.4470",
    source: "Hartler et al. (2017)",
    datasetId: 8,
    password: "phospholipid-example",
    file: "/files/MouseLiver_negative.mzTab"
  }
]


export const LoadSampleData = ({setToken}) => (
  <>
    <ul>
      <li>Quickly try out Fatty Acylizer by loading one of many provided example data sets.</li>
      <li>Submit the job and analyze the reconstructed fatty acyl profiles.</li>
      <li>Adjust the optimization parameters (fatty acids, start conditions, tolerances) if desired.</li>
    </ul>
    <h3>Examples</h3>
    <ExamplesTable setToken={setToken}/>
  </>
)

export const ExamplesTable = ({setToken}) => (
  <table className="table table-striped">
    <thead>
      <tr>
        <th>Data set</th>
        <th></th>
        <th>Lipid class</th>
        <th>DatasetId</th>
        <th>Password</th>
        <th></th>
        <th>Source</th>
      </tr>
    </thead>
    <tbody>
      {exampleDatasets.map(({dataset, lipidClass, url, source, datasetId, password, file}) => (
        <tr>
          <td>{dataset}</td>
          <td>
            <a
              className='btn btn-secondary btn-sm'
              target="_blank"
              href={file}
              download
              style={{whiteSpace: "nowrap", color: "white", textDecoration: "none"}}
            >
              <i className="fa-solid fa-download"></i> <>Download</>
            </a>
          </td>
          <td>{lipidClass}</td>
          <td>{datasetId}</td>
          <td>{password}</td>
          <td>
            <button 
              className='btn btn-primary btn-sm'
              type='button'
              onClick={() => loadDataset({setToken, datasetId, password})}
              style={{whiteSpace: "nowrap"}}
            >
            <i className="fa-solid fa-file-import"></i> Load
            </button>
          </td>
          <td>
            <a href={url}>{source}</a>
          </td>
        </tr>
      )
      )}
    </tbody>
  </table>
)
